export default "__VITE_ASSET__gU$se3KQ__"